import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { ProjectAndTaskCreationRequestModel } from "../models/project/request/projectAndTaskCreationRequest";
import { IProjectTaskComboDTO, ProjectTaskComboModel } from "../models/project/projectTaskCombo";
import { getTenantId } from "@/store/helper";
import { Guid } from "guid-typescript";
import { ProjectGridViewModel } from "../models/project/projectListing";
import { GuidItemModel } from "../models/shared/guidItem";
import { IPMOProjectDTO, PMOProjectModel } from "../models/project/PMOProject";
import { IPMOTaskCreationDTO } from "../models/project/PMOTaskCreation";
import { IProjectMembersDetailViewDTO, ProjectMembersDetailViewModel } from "../models/project/projectMembersDetailView";
import { ProjectMemberCreationModel } from "../models/project/projectMemberCreation";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { IPMOProjectSearchDataListingDTO, PMOProjectSearchDataModel } from "../models/project/PMOprojectSearchListingDTO";
import { ParentProjectListingModel } from "../models/project/parentProjectListing";
import { ILinkSubprojectToProjectDTO } from "../models/project/linkSubprojectToProject";
import { OwnedProjectModel } from "../models/project/ownedProject";
import { IPMOParentProjectDTO, PMOParentProjectModel } from "../models/project/PMOParentProject";
import { IProjectFilesStorageDTO, ProjectFilesStorageModel } from "../models/project/ProjectFilesStorage";
import _ from "lodash";
import { ProjectAnalyticsDetailViewModel } from "../models/project/ProjectAnalyticsDetailViewDTO";
import { IProjectTaskViewDTO, ProjectTaskViewModel } from "../models/project/projectTaskViewDTO";
import { ISubProjectsUnderParentProjectDTO, SubProjectsUnderParentProjectModel } from "../models/project/subProjectsUnderParentProjectDTO";
import { IRequestedUserDetailDTO } from "../models/project/requestedUserDetail";
import { NotificationsModule } from "./notification.module";
import { IPMOConvertTaskToProjectDTO } from "../models/project/convertTaskToProject";
import { IClockWorkSettingRequest } from "../models/project/request/clockWorkSettingRequest";
import { IProjectImpedimentDetailViewDTO, ProjectImpedimentDetailViewModel } from "../models/project/projectImpedimentDetailViewDTO";
import { IProjectImpedimentDTO } from "../models/project/projectImpedimentDTO";
import { Vue } from "vue-property-decorator";
import { PMOProjectTagModel } from "../models/project/PMOProjectTag";
import { PMOTagSimpleModel } from "../models/tag/PMOTagSimpleDTO";
let ProjectsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57;
    let ProjectsModule = class ProjectsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "project";
            this.projectTaskCombos = [];
            this.newProjectTaskCombo = new ProjectAndTaskCreationRequestModel();
            this.projectSelections = [];
            this.allProjectsForDefault = [];
            this.allTasksForDefault = [];
            this.taskSelections = [];
            this.projectGridViewEntries = [];
            this.projectDetailEntries = new PMOProjectModel();
            this.defaultProjectAndTask = null;
            this.projectMemberEntries = [];
            this.usersForParentProject = [];
            this.subProjects = [];
            this.tags = [];
            this.projectTags = [];
            this.member = null;
            this.requestedProjects = [];
            this.parentProjects = [];
            this.ownedProjects = [];
            this.parentProject = null;
            this.projectsUrlStorage = [];
            this.totalProjects = 0;
            this.projectAnalytics = [];
            this.projectAnalyticsDetail = new ProjectAnalyticsDetailViewModel();
            this.projectWorkEffortTotal = 0;
            this.projectDailyHoursCalculations = [];
            this.projectImpediments = [];
            this.isTaskOwner = false;
            this.searchParams = null;
        }
        async GetTopTenProjectTaskCombosForSelection() {
            var url = `${getTenantId()}/${this.apiNode}/recent-project-task-combo`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectTaskComboEntries(plainToClass(ProjectTaskComboModel, data.projectTaskCombos));
                return data.projectTaskCombos;
            }
        }
        async GetProjectListings(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetProjectListingEntries(plainToClass(ProjectGridViewModel, data.pmoProjects));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async SetTotalCount(totalCount) {
            this.totalProjects = totalCount;
        }
        async GetProjectDetailById(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/${projectId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectDetailEntries(plainToClass(PMOProjectModel, data.project));
                this.SetSubProjectEntries(plainToClass(SubProjectsUnderParentProjectModel, data.subProjects));
                this.SetProjectTags(plainToClass(PMOProjectTagModel, data.projectTags));
                this.SetTags(plainToClass(PMOTagSimpleModel, data.tags));
                this.SetParentProjectEntries(plainToClass(PMOParentProjectModel, data.parentProject));
                this.SetProjectUrl(plainToClass(ProjectFilesStorageModel, data.projectFilesStorage));
                this.projectDetailEntries.isAddSubProject = data.isAddSubProject;
                this.projectDetailEntries.isAccessForParentProject = data.isAccessForParentProject;
                this.projectDetailEntries.isAlreadyRequested = data.isRequested;
                this.projectDetailEntries.isLinked = data.isLinked;
                this.projectDetailEntries.isApexProject = data.isApexProject;
                this.projectDetailEntries.isProjectOwner = data.isProjectOwner;
                return data;
            }
        }
        async GetMembersForShareProject(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/${projectId}/eligible-member-list`;
            let { data } = await service.get(url);
            if (data) {
                this.SetMemberEntries(plainToClass(ProjectMembersDetailViewModel, data.projectMembersDetailView));
                return data.projectMembersDetailView;
            }
        }
        async AddProjectTeamMember(member) {
            var url = `${getTenantId()}/${this.apiNode}/add-project-teammember`;
            let { data } = await service.post(url, member);
            if (data) {
                this.SetAddedMember(plainToClass(ProjectMembersDetailViewModel, data.member));
                return data.member;
            }
        }
        async RemoveMemberFromProject(payload) {
            var url = `${getTenantId()}/${this.apiNode}/remove-project-member?projectId=${payload.projectId}&employeeId=${payload.employeeId}`;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveMember(payload.employeeId);
                return data;
            }
        }
        async CreateProjectTaskCombo() {
            var url = `${getTenantId()}/${this.apiNode}/create-project-task`;
            let { data } = await service.post(url, this.newProjectTaskCombo);
            if (data) {
                return data.taskId;
            }
        }
        async CreateProject(project) {
            var url = `${getTenantId()}/${this.apiNode}/create-project`;
            let { data } = await service.post(url, project);
            if (data) {
                return data;
            }
        }
        async UpdateProject(project) {
            var url = `${getTenantId()}/${this.apiNode}/update-project`;
            let { data } = await service.put(url, project);
            if (data) {
                return data;
            }
        }
        async GettingOwnedProjects(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/owned-projects?userId=${payLoad.userId}&projectId=${payLoad.projectId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetOwnedParentProjects(plainToClass(OwnedProjectModel, data.ownedProjects));
                return data.ownedProjects;
            }
        }
        async MovedTaskToProject(payload) {
            var url = `${getTenantId()}/${this.apiNode}/move-task?projectId=${payload.projectId}&taskId=${payload.taskId}`;
            let { data } = await service.post(url);
            if (data) {
                this.RemoveTasks(payload.taskId);
                return data;
            }
        }
        async MarkAsApexProject(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/markAsApexProject";
            let { data } = await service.put(url);
            if (data) {
                this.projectDetailEntries.isLinked = true;
                this.projectDetailEntries.isAlreadyRequested = true;
                return data;
            }
        }
        async RemoveAsApexProject(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/removeAsApexProject";
            let { data } = await service.delete(url);
            if (data) {
                this.projectDetailEntries.isLinked = false;
                this.projectDetailEntries.isAlreadyRequested = false;
                return data;
            }
        }
        async GetProjectsForSelection() {
            var url = `${getTenantId()}/${this.apiNode}/projects-selection`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectSelections(plainToClass(GuidItemModel, data.pmoProjectsKVP));
                this.SetTaskSelections([]);
                return data.pmoProjectsKVP;
            }
        }
        async GetProjectsForDefaultProject() {
            var url = `${getTenantId()}/${this.apiNode}/valid-projects-for-deafults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectSelections(plainToClass(GuidItemModel, data.pmoProjectsKVP));
                return data.pmoProjectsKVP;
            }
        }
        async GetTasksForSelection(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/tasks-selection?projectId=${projectId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetTaskSelections(plainToClass(GuidItemModel, data.pmoTasksKVP));
                return data.pmoTasksKVP;
            }
        }
        async CreateTaskUnderProject(task) {
            var url = `${getTenantId()}/${this.apiNode}/create-task-under-project`;
            let { data } = await service.post(url, task);
            if (data) {
                this.SetTask(plainToClass(ProjectTaskViewModel, data.task));
                return data.task;
            }
        }
        async AddDefaultProjectAndTask(clockWorkSettingRequest) {
            var url = `${getTenantId()}/${this.apiNode}/default-project-task`;
            let { data } = await service.post(url, clockWorkSettingRequest);
            if (data) {
                this.SetDefaultProjectAndTask(plainToClass(ProjectTaskComboModel, data.defaultProjectAndTask));
                ClockWorkModule.SetIsWFO(data.isWFO);
                ClockWorkModule.SetClockWorkWeekly(data.isClockWorkSetWeeklymail);
                return data;
            }
        }
        async RemoveDefaultProjectAndTask() {
            var url = `${getTenantId()}/${this.apiNode}/remove`;
            let { data } = await service.delete(url);
            if (data) {
                data = null;
                return ClockWorkModule.SetDefaultProject(data);
            }
        }
        async updateOwner(payload) {
            var url = `${getTenantId()}/${this.apiNode}/changeOwner?projectId=${payload.projectId}&employeeId=${payload.employeeId}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetUpdateOwner(plainToClass(ProjectMembersDetailViewModel, data.member));
                this.projectDetailEntries.isOwner = false;
                this.projectDetailEntries.isEditable = false;
                // this.projectDetailEntries.isAlreadyRequested = false;
                return data.member;
            }
        }
        async DeleteProjectById(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/deleteProject";
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async DeleteSubProjectById(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/deleteProject";
            let { data } = await service.delete(url);
            if (data) {
                this.Removeproject(projectId);
                return data;
            }
        }
        async DeLinkSubProjectById(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "delink-project/" + projectId;
            let { data } = await service.delete(url);
            if (data) {
                this.Removeproject(projectId);
                return data;
            }
        }
        async GetAllActiveUsersForParentProjects() {
            var url = `${getTenantId()}/${this.apiNode}/active-user-list`;
            let { data } = await service.get(url);
            if (data) {
                this.SetUsersForParentProject(plainToClass(ProjectMembersDetailViewModel, data.projectMembersDetailView));
                return data.projectMembersDetailView;
            }
        }
        async RequestToParentProject(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/subproject-request`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                this.projectDetailEntries.isAlreadyRequested = true;
                this.projectDetailEntries.isLinked = true;
                return data;
            }
        }
        async GetAllParentProjectForLinking(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/get-parentProjects-for-linking";
            let { data } = await service.get(url);
            if (data) {
                this.SetParentProjects(plainToClass(ParentProjectListingModel, data.parentProjects));
                return data.parentProjects;
            }
        }
        async LinkSubprojectToProject(dto) {
            var url = `${getTenantId()}/${this.apiNode}/link-subproject-to-project`;
            let { data } = await service.post(url, dto);
            if (data) {
                NotificationsModule.SetIsActive(dto.notificationId);
                return data;
            }
        }
        async CreateSubProject(payload) {
            var url = `${getTenantId()}/${this.apiNode}/${payload.projectId}/sub-projects`;
            let { data } = await service.post(url, payload.project);
            if (data) {
                this.GetAllParentProjects(plainToClass(SubProjectsUnderParentProjectModel, data.subProjects));
                return data;
            }
        }
        async CreateLink(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/${payLoad.projectId}/AddFileUrl`;
            let { data } = await service.post(url, payLoad.projectFileLink);
            if (data) {
                this.SetLink(plainToClass(ProjectFilesStorageModel, data.projectFileLink));
                return data;
            }
        }
        async UpdateLink(editFileLink) {
            var url = `${getTenantId()}/${this.apiNode}/UpdateFileUrl`;
            let { data } = await service.post(url, editFileLink);
            if (data) {
                this.SetLink(plainToClass(ProjectFilesStorageModel, data.projectFileLink));
                return data;
            }
        }
        async DeleteLinkById(linkId) {
            var url = `${getTenantId()}/${this.apiNode}/${linkId}/DeleteFileUrl`;
            let { data } = await service.delete(url);
            if (data) {
                this.Removelink(linkId);
                return data;
            }
        }
        async AddProjectToWatchList(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/${projectId}/WatchList`;
            let { data } = await service.get(url);
            if (data) {
                this.projectDetailEntries.isWatching = true;
                return data;
            }
        }
        async RemoveProjectFromWatchList(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/${projectId}/RemoveFromWatchList`;
            let { data } = await service.delete(url);
            if (data) {
                this.projectDetailEntries.isWatching = false;
                return data;
            }
        }
        async ConvertTaskToProject(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/convert-task-to-project/`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                if (!payLoad.isMainProject) {
                    this.AppendSubProjects(data.projectDetail);
                }
                this.RemoveTasks(payLoad.taskId);
                return data;
            }
        }
        async GetTasksForProject(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "tasks/" + projectId;
            let { data } = await service.get(url);
            if (data) {
                this.SetTaskHours(plainToClass(ProjectTaskViewModel, data.tasks));
                return data;
            }
        }
        //Project Impediments
        async GetProjectImpediments(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + "impediments/" + projectId;
            let { data } = await service.get(url);
            if (data) {
                this.SetImpediments(plainToClass(ProjectImpedimentDetailViewModel, data.projectImpediments));
                return data.projectImpediments;
            }
        }
        async AddImpedimentsToProject(impediment) {
            var url = `${getTenantId()}/${this.apiNode}/impediments/add`;
            let { data } = await service.post(url, impediment);
            if (data) {
                this.AppendImpediment(plainToClass(ProjectImpedimentDetailViewModel, data.projectImpediment));
                return data;
            }
        }
        async DeleteImpediment(impedimentId) {
            var url = `${getTenantId()}/${this.apiNode}/impediments/delete/` + impedimentId;
            let { data } = await service.delete(url);
            this.RemoveImpediment(impedimentId);
            return data;
        }
        async ResolveImpediment(impedimentId) {
            var url = `${getTenantId()}/${this.apiNode}/impediments/resolve/` + impedimentId;
            let { data } = await service.post(url);
            if (data) {
                this.SetResolver(data.projectImpediment);
                return data;
            }
        }
        SetResolver(impediments) {
            const existingIndex = this.projectImpediments.findIndex((x) => x.id === impediments.id);
            if (existingIndex === -1 || this.projectImpediments[existingIndex].resolvedBy !== null) {
                return;
            }
            this.projectImpediments[existingIndex].resolvedBy = impediments.resolvedBy;
            this.projectImpediments[existingIndex].resolverName = impediments.resolverName;
            this.projectImpediments[existingIndex].resolvedOn = impediments.resolvedOn;
            this.projectImpediments[existingIndex].isResolved = impediments.isResolved;
        }
        AppendImpediment(impediments) {
            this.projectImpediments.push(impediments);
        }
        ImpedimentIncrementCount() {
            this.projectDetailEntries.unResolvedImpediment += 1;
        }
        ImpedimentDecrementCount() {
            this.projectDetailEntries.unResolvedImpediment -= 1;
        }
        SetImpediments(impediments) {
            this.projectImpediments = impediments;
        }
        RemoveImpediment(impedimentId) {
            var index = this.projectImpediments.findIndex((x) => x.id == impedimentId);
            if (index > -1) {
                this.projectImpediments.splice(index, 1);
                this.projectDetailEntries.unResolvedImpediment -= 1;
            }
        }
        SetTaskHours(tasks) {
            Vue.set(this.projectDetailEntries, "tasks", tasks);
        }
        ClearProjectDetails() {
            for (const key in this.projectDetailEntries) {
                if (this.projectDetailEntries.hasOwnProperty(key)) {
                    if (typeof this.projectDetailEntries[key] === "number") {
                        Vue.set(this.projectDetailEntries, key, 0);
                    }
                    else if (typeof this.projectDetailEntries[key] === "boolean") {
                        Vue.set(this.projectDetailEntries, key, false);
                    }
                    else if (Array.isArray(this.projectDetailEntries[key])) {
                        Vue.set(this.projectDetailEntries, key, []);
                    }
                    else {
                        Vue.set(this.projectDetailEntries, key, "");
                    }
                }
            }
        }
        AppendSubProjects(projectDetail) {
            this.subProjects.push(projectDetail);
        }
        RemoveTasks(taskId) {
            const index = this.projectDetailEntries.tasks.findIndex((x) => x.id === taskId);
            if (index !== -1) {
                this.projectDetailEntries.tasks.splice(index, 1);
            }
        }
        Removelink(linkId) {
            var index = this.projectsUrlStorage.findIndex((x) => x.id == linkId);
            if (index > -1) {
                this.projectsUrlStorage.splice(index, 1);
            }
        }
        Removeproject(projectId) {
            var index = this.subProjects.findIndex((x) => x.id == projectId);
            if (index > -1) {
                this.subProjects.splice(index, 1);
            }
        }
        SetLink(projectFileLink) {
            var that = this;
            if (that.projectsUrlStorage != null) {
                var target = that.projectsUrlStorage.findIndex((x) => x.id == projectFileLink.id);
                if (target !== -1) {
                    that.projectsUrlStorage[target] = plainToClass(ProjectFilesStorageModel, projectFileLink);
                }
                else {
                    that.projectsUrlStorage.push(plainToClass(ProjectFilesStorageModel, projectFileLink));
                }
                that.projectsUrlStorage = _.sortBy(that.projectsUrlStorage, (x) => x.uploadedOn, "uploadedOn").reverse();
                that.projectsUrlStorage = [...that.projectsUrlStorage];
            }
        }
        GetAllParentProjects(subProjects) {
            var that = this;
            that.subProjects.push(plainToClass(SubProjectsUnderParentProjectModel, subProjects));
            that.subProjects = _.sortBy(that.subProjects, (x) => x.createdOn, "createdOn").reverse();
        }
        async InitializeProjectTaskCombo() {
            this.newProjectTaskCombo = new ProjectAndTaskCreationRequestModel();
        }
        SetProjectTaskComboEntries(entries) {
            this.projectTaskCombos = entries;
        }
        SetProjectSelections(entries) {
            this.projectSelections = entries;
            this.allProjectsForDefault = entries;
        }
        SetTaskSelections(entries) {
            this.taskSelections = entries;
            this.allTasksForDefault = entries;
        }
        SetProjectListingEntries(entries) {
            this.projectGridViewEntries = entries;
        }
        SetProjectDetailEntries(entries) {
            const { tasks, ...sourceWithoutTasks } = entries;
            Object.assign(this.projectDetailEntries, sourceWithoutTasks);
        }
        SetSubProjectEntries(subProjects) {
            this.subProjects = subProjects;
        }
        SetTags(tags) {
            this.tags = tags;
        }
        SetProjectTags(projectTags) {
            this.projectTags = projectTags;
        }
        SetParentProjectEntries(parentProject) {
            this.parentProject = parentProject;
        }
        SetProjectUrl(projectsUrlStorage) {
            this.projectsUrlStorage = projectsUrlStorage;
        }
        SetMemberEntries(entries) {
            this.projectMemberEntries = entries;
        }
        SetUsersForParentProject(entries) {
            this.usersForParentProject = entries;
        }
        clearUser() {
            this.usersForParentProject = [];
        }
        clearProject() {
            this.ownedProjects = [];
        }
        SetDefaultProjectAndTask(entries) {
            this.defaultProjectAndTask = entries;
            ClockWorkModule.SetDefaultProject(entries);
        }
        SetAddedMember(member) {
            var that = this;
            var target = that.projectDetailEntries.members.findIndex((x) => x.employeeId == member.employeeId);
            const memberToAdd = plainToClass(ProjectMembersDetailViewModel, member);
            memberToAdd.isActiveMember = true;
            if (target !== -1) {
                that.projectDetailEntries.members[target] = memberToAdd;
            }
            else {
                that.projectDetailEntries.members.push(memberToAdd);
            }
            that.projectDetailEntries.members = [...that.projectDetailEntries.members];
        }
        SetTask(task) {
            var that = this;
            if (that.projectDetailEntries != null) {
                var target = that.projectDetailEntries.tasks.findIndex((x) => x.id == task.id);
                if (target !== -1) {
                    that.projectDetailEntries.tasks[target] = plainToClass(ProjectTaskViewModel, task);
                }
                else {
                    that.projectDetailEntries.tasks.push(plainToClass(ProjectTaskViewModel, task));
                }
                that.projectDetailEntries.tasks = [...that.projectDetailEntries.tasks];
            }
        }
        SetUpdateOwner(member) {
            this.projectDetailEntries.ownedBy = member.employeeId;
        }
        RemoveMember(employeeId) {
            var index = this.projectDetailEntries.members.findIndex((x) => x.employeeId == employeeId);
            if (index > -1) {
                this.projectDetailEntries.members.splice(index, 1);
            }
        }
        async UpdateTask(editTask) {
            var url = `${getTenantId()}/${this.apiNode}/update-task`;
            let { data } = await service.post(url, editTask);
            return data;
        }
        async DeleteTask(taskId) {
            var url = `${getTenantId()}/${this.apiNode}/Delete-task/` + taskId;
            let { data } = await service.delete(url);
            this.RemoveTasks(taskId);
            return data;
        }
        SetRequestedProjects(requestedProjects) {
            this.requestedProjects = requestedProjects;
        }
        SetParentProjects(parentProjects) {
            this.parentProjects = parentProjects;
        }
        async GetOwnedParentProjects(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/` + projectId + "/get-owned-parent-projects";
            let { data } = await service.get(url);
            if (data) {
                this.SetOwnedParentProjects(plainToClass(OwnedProjectModel, data.ownedProjects));
                return data.ownedProjects;
            }
        }
        SetOwnedParentProjects(ownedProjects) {
            this.ownedProjects = ownedProjects;
        }
        async LinkSubprojectToOwnedProject(dto) {
            var url = `${getTenantId()}/${this.apiNode}/link-subproject-to-ownedproject`;
            let { data } = await service.post(url, dto);
            if (data) {
                this.projectDetailEntries.isLinked = true;
                this.projectDetailEntries.isAlreadyRequested = true;
                return data;
            }
        }
        async GetProjectsHierarchicalList(selectedFilters) {
            var url = `${getTenantId()}/${this.apiNode}/analytics?selectedFilters=${selectedFilters}`;
            let { data } = await service.post(url);
            if (data) {
                this.SetProjectAnalytics(data.projectAnalytics);
                return data;
            }
            return Promise.reject(false);
        }
        SetProjectAnalytics(projectAnalytics) {
            this.projectAnalytics = projectAnalytics;
        }
        async GetProjectAnalyticById(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/${payLoad.projectId}/analytics?operation=${payLoad.operation}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectAnalyticsDetail({ data: data });
                return data;
            }
            return Promise.reject(false);
        }
        async GetTotalTimeForProject(projectId) {
            var url = `${getTenantId()}/${this.apiNode}/${projectId}/projectTotalTime`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectTotalTime(data.projectWorkEffortTotal);
                return data;
            }
            return Promise.reject(false);
        }
        async GetProjectanalyticsTeamMemberDetails(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/${payLoad.projectId}/analytics/details?operation=${payLoad.operation}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetProjectAnalyticsTeamMemberDetails({ data: data });
                return data;
            }
            return Promise.reject(false);
        }
        SetProjectAnalyticsTeamMemberDetails(payLoad) {
            this.projectAnalyticsDetail.projectAnalyticsMembersDetail.teamMembers = payLoad.data.memberDetails.teamMembers;
            payLoad.data.memberDetails.teamMembers.forEach((y) => {
                let value = y.timeEffort / 60;
                let hours = Math.floor(value / 60);
                let minutes = value % 60;
                let formattedMinutes = minutes.toFixed(0);
                y.timeEffortAsString = hours + " Hrs " + formattedMinutes + " m";
            });
            this.projectDailyHoursCalculations = payLoad.data.memberDetails.projectDailyHoursCalculations;
        }
        SetProjectAnalyticsDetail(payLoad) {
            this.projectAnalyticsDetail.id = payLoad.data.projectAnalyticsDetail.id;
            this.projectAnalyticsDetail.code = payLoad.data.projectAnalyticsDetail.code;
            this.projectAnalyticsDetail.parentProject = payLoad.data.projectAnalyticsDetail.parentProject;
            this.projectAnalyticsDetail.projectDueDateAsString = payLoad.data.projectAnalyticsDetail.projectDueDateAsString;
            this.projectAnalyticsDetail.projectStartDateAsString = payLoad.data.projectAnalyticsDetail.projectStartDateAsString;
            this.projectAnalyticsDetail.subProjectsCount = payLoad.data.projectAnalyticsDetail.subProjectsCount;
            this.projectAnalyticsDetail.projectName = payLoad.data.projectAnalyticsDetail.projectName;
            this.projectAnalyticsDetail.projectTasksCount = payLoad.data.projectAnalyticsDetail.projectTasksCount;
            this.projectAnalyticsDetail.projectFilesCount = payLoad.data.projectAnalyticsDetail.projectFilesCount;
            this.projectAnalyticsDetail.projectOwnerId = payLoad.data.projectAnalyticsDetail.projectOwnerId;
            this.projectAnalyticsDetail.projectWorkEfforsCount = payLoad.data.projectAnalyticsDetail.projectWorkEfforsCount;
            payLoad.data.projectAnalyticsDetail.projectAnalyticsMembersDetail.teamMembers.forEach((y) => {
                let value = y.timeEffort / 60;
                let hours = Math.floor(value / 60);
                let minutes = value % 60;
                let formattedMinutes = minutes.toFixed(0);
                y.timeEffortAsString = hours + " Hrs " + formattedMinutes + " m";
            });
            this.projectAnalyticsDetail.projectAnalyticsMembersDetail = payLoad.data.projectAnalyticsDetail.projectAnalyticsMembersDetail;
            this.projectDailyHoursCalculations = payLoad.data.projectAnalyticsDetail.projectAnalyticsMembersDetail.projectDailyHoursCalculations;
        }
        SetProjectTotalTime(totalCount) {
            this.projectAnalyticsDetail.projectWorkEffortTotal = totalCount;
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], ProjectsModule.prototype, "GetTopTenProjectTaskCombosForSelection", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IPMOProjectSearchDataListingDTO !== "undefined" && IPMOProjectSearchDataListingDTO) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], ProjectsModule.prototype, "GetProjectListings", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "SetTotalCount", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], ProjectsModule.prototype, "GetProjectDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Guid !== "undefined" && Guid) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], ProjectsModule.prototype, "GetMembersForShareProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof ProjectMemberCreationModel !== "undefined" && ProjectMemberCreationModel) === "function" ? _h : Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], ProjectsModule.prototype, "AddProjectTeamMember", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "RemoveMemberFromProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], ProjectsModule.prototype, "CreateProjectTaskCombo", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof IPMOProjectDTO !== "undefined" && IPMOProjectDTO) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], ProjectsModule.prototype, "CreateProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof IPMOProjectDTO !== "undefined" && IPMOProjectDTO) === "function" ? _o : Object]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], ProjectsModule.prototype, "UpdateProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], ProjectsModule.prototype, "GettingOwnedProjects", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "MovedTaskToProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof Guid !== "undefined" && Guid) === "function" ? _r : Object]),
        __metadata("design:returntype", typeof (_s = typeof Promise !== "undefined" && Promise) === "function" ? _s : Object)
    ], ProjectsModule.prototype, "MarkAsApexProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_t = typeof Guid !== "undefined" && Guid) === "function" ? _t : Object]),
        __metadata("design:returntype", typeof (_u = typeof Promise !== "undefined" && Promise) === "function" ? _u : Object)
    ], ProjectsModule.prototype, "RemoveAsApexProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], ProjectsModule.prototype, "GetProjectsForSelection", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_w = typeof Promise !== "undefined" && Promise) === "function" ? _w : Object)
    ], ProjectsModule.prototype, "GetProjectsForDefaultProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_x = typeof Guid !== "undefined" && Guid) === "function" ? _x : Object]),
        __metadata("design:returntype", typeof (_y = typeof Promise !== "undefined" && Promise) === "function" ? _y : Object)
    ], ProjectsModule.prototype, "GetTasksForSelection", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_z = typeof IPMOTaskCreationDTO !== "undefined" && IPMOTaskCreationDTO) === "function" ? _z : Object]),
        __metadata("design:returntype", typeof (_0 = typeof Promise !== "undefined" && Promise) === "function" ? _0 : Object)
    ], ProjectsModule.prototype, "CreateTaskUnderProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_1 = typeof IClockWorkSettingRequest !== "undefined" && IClockWorkSettingRequest) === "function" ? _1 : Object]),
        __metadata("design:returntype", typeof (_2 = typeof Promise !== "undefined" && Promise) === "function" ? _2 : Object)
    ], ProjectsModule.prototype, "AddDefaultProjectAndTask", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "RemoveDefaultProjectAndTask", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
    ], ProjectsModule.prototype, "updateOwner", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_4 = typeof Guid !== "undefined" && Guid) === "function" ? _4 : Object]),
        __metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
    ], ProjectsModule.prototype, "DeleteProjectById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_6 = typeof Guid !== "undefined" && Guid) === "function" ? _6 : Object]),
        __metadata("design:returntype", typeof (_7 = typeof Promise !== "undefined" && Promise) === "function" ? _7 : Object)
    ], ProjectsModule.prototype, "DeleteSubProjectById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof Guid !== "undefined" && Guid) === "function" ? _8 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "DeLinkSubProjectById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_9 = typeof Promise !== "undefined" && Promise) === "function" ? _9 : Object)
    ], ProjectsModule.prototype, "GetAllActiveUsersForParentProjects", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_10 = typeof IRequestedUserDetailDTO !== "undefined" && IRequestedUserDetailDTO) === "function" ? _10 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "RequestToParentProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_11 = typeof Guid !== "undefined" && Guid) === "function" ? _11 : Object]),
        __metadata("design:returntype", typeof (_12 = typeof Promise !== "undefined" && Promise) === "function" ? _12 : Object)
    ], ProjectsModule.prototype, "GetAllParentProjectForLinking", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_13 = typeof ILinkSubprojectToProjectDTO !== "undefined" && ILinkSubprojectToProjectDTO) === "function" ? _13 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "LinkSubprojectToProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_14 = typeof Promise !== "undefined" && Promise) === "function" ? _14 : Object)
    ], ProjectsModule.prototype, "CreateSubProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
    ], ProjectsModule.prototype, "CreateLink", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_16 = typeof IProjectFilesStorageDTO !== "undefined" && IProjectFilesStorageDTO) === "function" ? _16 : Object]),
        __metadata("design:returntype", typeof (_17 = typeof Promise !== "undefined" && Promise) === "function" ? _17 : Object)
    ], ProjectsModule.prototype, "UpdateLink", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_18 = typeof Guid !== "undefined" && Guid) === "function" ? _18 : Object]),
        __metadata("design:returntype", typeof (_19 = typeof Promise !== "undefined" && Promise) === "function" ? _19 : Object)
    ], ProjectsModule.prototype, "DeleteLinkById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_20 = typeof Guid !== "undefined" && Guid) === "function" ? _20 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "AddProjectToWatchList", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_21 = typeof Guid !== "undefined" && Guid) === "function" ? _21 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "RemoveProjectFromWatchList", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_22 = typeof IPMOConvertTaskToProjectDTO !== "undefined" && IPMOConvertTaskToProjectDTO) === "function" ? _22 : Object]),
        __metadata("design:returntype", typeof (_23 = typeof Promise !== "undefined" && Promise) === "function" ? _23 : Object)
    ], ProjectsModule.prototype, "ConvertTaskToProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_24 = typeof Guid !== "undefined" && Guid) === "function" ? _24 : Object]),
        __metadata("design:returntype", typeof (_25 = typeof Promise !== "undefined" && Promise) === "function" ? _25 : Object)
    ], ProjectsModule.prototype, "GetTasksForProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_26 = typeof Guid !== "undefined" && Guid) === "function" ? _26 : Object]),
        __metadata("design:returntype", typeof (_27 = typeof Promise !== "undefined" && Promise) === "function" ? _27 : Object)
    ], ProjectsModule.prototype, "GetProjectImpediments", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_28 = typeof IProjectImpedimentDTO !== "undefined" && IProjectImpedimentDTO) === "function" ? _28 : Object]),
        __metadata("design:returntype", typeof (_29 = typeof Promise !== "undefined" && Promise) === "function" ? _29 : Object)
    ], ProjectsModule.prototype, "AddImpedimentsToProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_30 = typeof Guid !== "undefined" && Guid) === "function" ? _30 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "DeleteImpediment", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_31 = typeof Guid !== "undefined" && Guid) === "function" ? _31 : Object]),
        __metadata("design:returntype", typeof (_32 = typeof Promise !== "undefined" && Promise) === "function" ? _32 : Object)
    ], ProjectsModule.prototype, "ResolveImpediment", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_33 = typeof IProjectImpedimentDetailViewDTO !== "undefined" && IProjectImpedimentDetailViewDTO) === "function" ? _33 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetResolver", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_34 = typeof ProjectImpedimentDetailViewModel !== "undefined" && ProjectImpedimentDetailViewModel) === "function" ? _34 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "AppendImpediment", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "ImpedimentIncrementCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "ImpedimentDecrementCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetImpediments", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_35 = typeof Guid !== "undefined" && Guid) === "function" ? _35 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "RemoveImpediment", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetTaskHours", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "ClearProjectDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_36 = typeof ISubProjectsUnderParentProjectDTO !== "undefined" && ISubProjectsUnderParentProjectDTO) === "function" ? _36 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "AppendSubProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "RemoveTasks", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_37 = typeof Guid !== "undefined" && Guid) === "function" ? _37 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "Removelink", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_38 = typeof Guid !== "undefined" && Guid) === "function" ? _38 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "Removeproject", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_39 = typeof IProjectFilesStorageDTO !== "undefined" && IProjectFilesStorageDTO) === "function" ? _39 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetLink", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_40 = typeof ISubProjectsUnderParentProjectDTO !== "undefined" && ISubProjectsUnderParentProjectDTO) === "function" ? _40 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "GetAllParentProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "InitializeProjectTaskCombo", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectTaskComboEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectSelections", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetTaskSelections", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectListingEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_41 = typeof IPMOProjectDTO !== "undefined" && IPMOProjectDTO) === "function" ? _41 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectDetailEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetSubProjectEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetTags", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectTags", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_42 = typeof IPMOParentProjectDTO !== "undefined" && IPMOParentProjectDTO) === "function" ? _42 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetParentProjectEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectUrl", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetMemberEntries", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetUsersForParentProject", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "clearUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "clearProject", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_43 = typeof IProjectTaskComboDTO !== "undefined" && IProjectTaskComboDTO) === "function" ? _43 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetDefaultProjectAndTask", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_44 = typeof IProjectMembersDetailViewDTO !== "undefined" && IProjectMembersDetailViewDTO) === "function" ? _44 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetAddedMember", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_45 = typeof IProjectTaskViewDTO !== "undefined" && IProjectTaskViewDTO) === "function" ? _45 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetTask", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_46 = typeof IProjectMembersDetailViewDTO !== "undefined" && IProjectMembersDetailViewDTO) === "function" ? _46 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetUpdateOwner", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_47 = typeof Guid !== "undefined" && Guid) === "function" ? _47 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "RemoveMember", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_48 = typeof IProjectTaskViewDTO !== "undefined" && IProjectTaskViewDTO) === "function" ? _48 : Object]),
        __metadata("design:returntype", typeof (_49 = typeof Promise !== "undefined" && Promise) === "function" ? _49 : Object)
    ], ProjectsModule.prototype, "UpdateTask", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_50 = typeof Promise !== "undefined" && Promise) === "function" ? _50 : Object)
    ], ProjectsModule.prototype, "DeleteTask", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetRequestedProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetParentProjects", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_51 = typeof Promise !== "undefined" && Promise) === "function" ? _51 : Object)
    ], ProjectsModule.prototype, "GetOwnedParentProjects", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetOwnedParentProjects", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_52 = typeof ILinkSubprojectToProjectDTO !== "undefined" && ILinkSubprojectToProjectDTO) === "function" ? _52 : Object]),
        __metadata("design:returntype", Promise)
    ], ProjectsModule.prototype, "LinkSubprojectToOwnedProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_53 = typeof Promise !== "undefined" && Promise) === "function" ? _53 : Object)
    ], ProjectsModule.prototype, "GetProjectsHierarchicalList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectAnalytics", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_54 = typeof Promise !== "undefined" && Promise) === "function" ? _54 : Object)
    ], ProjectsModule.prototype, "GetProjectAnalyticById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_55 = typeof Promise !== "undefined" && Promise) === "function" ? _55 : Object)
    ], ProjectsModule.prototype, "GetTotalTimeForProject", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_56 = typeof Promise !== "undefined" && Promise) === "function" ? _56 : Object)
    ], ProjectsModule.prototype, "GetProjectanalyticsTeamMemberDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectAnalyticsTeamMemberDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectAnalyticsDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "SetProjectTotalTime", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_57 = typeof PMOProjectSearchDataModel !== "undefined" && PMOProjectSearchDataModel) === "function" ? _57 : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectsModule.prototype, "ClearSearchParams", null);
    ProjectsModule = __decorate([
        Module({ dynamic: true, store: store, name: "projects", namespaced: true })
    ], ProjectsModule);
    return ProjectsModule;
})();
export const ProjectModule = getModule(ProjectsModule);
